import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-957329a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confirm-exchange-coupon p-3" }
const _hoisted_2 = { class: "section1" }
const _hoisted_3 = { class: "gift-item" }
const _hoisted_4 = { class: "gift-item__title text-black text-size-18 text-weight-600" }
const _hoisted_5 = { class: "d-flex align-items-end justify-content-between mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-12" }, "使用ポイント", -1))
const _hoisted_7 = { class: "text-size-18 text-weight-600" }
const _hoisted_8 = { class: "section2" }
const _hoisted_9 = { class: "bg-white border border-outline-color px-3 mt-3 round-4" }
const _hoisted_10 = { class: "border-bottom border-outline-color" }
const _hoisted_11 = { class: "d-flex border-bottom border-outline-color py-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "point-label text-size-14" }, "現ポイント", -1))
const _hoisted_13 = { class: "text-size-14 ml-4" }
const _hoisted_14 = { class: "d-flex py-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "point-label text-size-14" }, "交換後ポイント", -1))
const _hoisted_16 = { class: "text-size-14 ml-4" }
const _hoisted_17 = { class: "section3" }

import { computed, onBeforeMount, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { accountService } from "@/app/services/AccountService";
import { giftService } from "@/app/services/GiftService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import { authStore } from "@/store/auth";
import { Gift } from "@/types/Gift";
import { formatNumber } from "@/utils/number";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import { useCustomRouter } from "@/utils/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmExchangeCoupon',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const loader = useLoader();
const errorModal = useErrorModal();
const customRouter = useCustomRouter();

const giftId = ref(0);
const gift = ref<Gift>({
  id: 0,
  createdAt: "",
  updatedAt: "",
  giftName: "...",
  giftType: "goods",
  requiredPoint: 0
});

const user = computed(() => authStore.user!);
const requiredPoint = computed(() => gift.value.requiredPoint);
const point = computed(() => user.value.caisukePoint);
const afterExchangePoint = computed(() => point.value - requiredPoint.value);
const canExchange = computed(() => point.value >= requiredPoint.value);

onBeforeMount(async () => {
  loader.show();
  try {
    giftId.value = Number(route.params.giftId);

    // アカウント情報を更新
    await accountService.updateUserData();

    const result = await giftService.fetchPointGift(giftId.value);
    if (result) {
      gift.value = result;
    }
  } catch (err) {
    await errorModal.showErrorModal(err as Error);
  } finally {
    loader.hide();
  }
});
function onClickBack() {
  router.back();
}
async function requestExchangeGift() {
  loader.show();
  try {
    await giftService.requestExchange({ gift: giftId.value });
    await customRouter.pushIgnoreError({ name: "ExchangeCouponFinished" });
  } catch (err) {
    await errorModal.showErrorModal(err as Error);
  } finally {
    loader.hide();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      交換の確認\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(gift.value.giftName), 1)
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _hoisted_6,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(formatNumber)(requiredPoint.value)), 1)
            ])
          ])
        ])
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(formatNumber)(point.value)) + "pt\n              ", 1)
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createTextVNode(),
              _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(formatNumber)(afterExchangePoint.value)) + "pt\n              ", 1)
            ])
          ])
        ])
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(AppButton, {
          block: "",
          variant: "primary",
          disabled: !canExchange.value,
          onClick: requestExchangeGift
        }, {
          default: _withCtx(() => [
            _createTextVNode("交換を申請")
          ], undefined, true),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})